<template>
    <v-layout align-start>
        <v-flex>
            <v-data-table
            :headers="headers"
            :items="catUsuario"
            :search="search"
            :options.sync="options"
            :server-items-length="totalItems"
            class="elevation-1">
            <template v-slot:top>
                <v-toolbar flat color="white">
                <v-toolbar-title>Asignar superior inmediato</v-toolbar-title>
                <v-divider
                    class="mx-4"
                    inset
                    vertical
                ></v-divider>
                <v-spacer></v-spacer>
                <v-text-field class="text-xs-center" 
                    v-model="search" 
                    append-icon="search" 
                     @click:append="listar"
                    @keyup.enter="listar"
                    label="Busqueda" 
                    single-line hide-details>
                </v-text-field>
               
                <v-spacer></v-spacer>

                <!--/////////////*****/ DIALOG  -->
                    <v-dialog v-model="dialog" fullscreen 
                        hide-overlay transition="dialog-bottom-transition">
                        <!-- <template v-slot:activator="{ on }">
                            <v-btn color="primary" 
                                dark v-on="on" 
                                @click="newItem"
                                outlined>Asignar grupo</v-btn>
                        </template> -->
                        <v-card>
                            <v-toolbar dark color="primary">
                                <v-btn icon dark @click="dialog = false">
                                    <v-icon>close</v-icon>
                                </v-btn>
                                <v-toolbar-title><span class="headline">Asignar jefe inmediato</span></v-toolbar-title>
                                <v-spacer></v-spacer>
                                <!-- <v-btn class="ma-2" @click="Limpiar()" outlined color="indigo">Limpiar Controles</v-btn> -->
                                <v-spacer></v-spacer>
                                <v-toolbar-items>
                                    <v-btn 
                                        @click="saveChange"
                                        dark text>
                                        Grabar
                                    </v-btn>
                                </v-toolbar-items>
                            </v-toolbar>  
                            <v-card flat>
                                <v-card-text>
                                    <h2>{{TituloNombre}}</h2>   
                                
                                </v-card-text>
                             </v-card>
                                        
                            <v-list three-line subheader>       
                                <!-- <v-subheader><strong> Seleccione Tipo de grupo</strong></v-subheader> -->
                                <v-container fluid>
                                    <v-row>
                                        <v-col cols="12" sm="12" md="12">
                                         <template>
                                              <v-simple-table fixed-header>
                                                <thead>
                                                    <tr>
                                                        <th class="text-left">Nombre</th>
                                                        <th class="text-left">NoEmpleado</th>
                                                        <th class="text-left">Correo</th>
                                                        <th class="text-left">Asignar</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(item, index) in catUsuarioSuperior" :key="index">
                                                        <td>{{ item.nombre }}</td>
                                                        <td>{{ item.noEmpleado }}</td>
                                                        <td>{{ item.correo }}</td>
                                                        <td>    
                                                            <v-container fluid>
                                                                <v-checkbox v-model="item.vigencia" :value=item.vigencia></v-checkbox>
                                                            </v-container>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                             </v-simple-table>
                                         </template>
                                       
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-list>
                        </v-card>
                        <v-divider></v-divider>
                    </v-dialog>


                     <v-dialog v-model="dialogconfirm" max-width="290">
                    <v-card>
                        <v-card-title class="headline">Buen trabajo</v-card-title>
                        <v-card-text>
                           Se ha cargado el layout, verificar el excel de estatus de las asignaciones.
                            <br>
                           <v-avatar size="32px" tile>
                              <img
                                :src="`/580b57fcd9996e24bc43c452.png`"
                              >
                                    
                           </v-avatar>
                        </v-card-text>
                        
                        <v-card-actions>
                        <v-spacer></v-spacer>
                        
                        <v-btn
                            color="green darken-1"
                            text
                             @click="dialogconfirm = false"
                        >
                            Aceptar
                        </v-btn>
                       
                        </v-card-actions>
                    </v-card>
                </v-dialog>


                 <!--/////////////*****/END DIALOG  -->
                 <div class="text-center">
                      <v-bottom-sheet v-model="sheet">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            color="default"
                            dark
                            v-bind="attrs"
                            v-on="on"
                          >
                            Carga masiva
                          </v-btn>
                        </template>
                        <v-list>
                          <v-subheader>Layout de Jerarquia</v-subheader>
                            <v-container fluid>
                              <v-row>
                                <v-col cols="12" sm="12" md="12">
                                  <v-list-item
                                    v-for="tile in tiles"
                                    :key="tile.title"
                                    @click="descargaArchivo"
                                  >
                                    <v-list-item-avatar>
                                      <v-avatar size="32px" tile>
                                        <img
                                          :src="`/excel.png`"
                                          :alt="tile.title"
                                        >
                                    
                                      </v-avatar>
                                      
                                    </v-list-item-avatar>
                                  
                                    <v-list-item-title>{{ tile.title }}</v-list-item-title>
                                  </v-list-item>
                                </v-col>
                                </v-row>
                               <v-row>
                                  <v-col cols="6" sm="6" md="6">
                                    <v-file-input label="Selecciona archivo" v-model="file" outlined dense></v-file-input>
                                  </v-col>
                                   <v-col cols="6" sm="6" md="6">
                                    <v-spacer></v-spacer>
                                       <v-btn right @click="uploadFile">Subir archivo</v-btn>
                                  </v-col>
                               </v-row>
                            </v-container>
                             
                        </v-list>
                      </v-bottom-sheet>
                    </div>
                </v-toolbar>
            </template> 
            <template v-slot:body="{ items }">
                <tbody>
                    <tr v-for="(item, index) in items" :key="index">
                         <td>
                           <div>
                                 <v-tooltip top>
                                    <template v-slot:activator="{ on }">
                                    <v-btn icon v-on="on">
                                       <v-icon small class="mr-2" @click="select(item)">
                                            pan_tool 
                                      </v-icon>
                                    </v-btn>
                                    </template>
                                    <span>Seleccionar</span>
                                </v-tooltip>
                               
                            </div>
                        </td>
                        <td>{{ item.nombre }}</td>
                        <td>{{ item.noEmpleado }}</td>
                        <td>{{ item.correo }}</td>
                    </tr>
                </tbody>
            </template>
            </v-data-table>
        </v-flex>
    </v-layout>
</template>  

<script>
import axios from 'axios'
import moment from 'moment'

export default {
   created () {
        this.listar()
    },
    data() {
        return {
            catUsuario:[],
            TituloNombre:'',
            catUsuarioSuperior:[],
            selectUser: {},
            selectSup: [],
            options: {},
            dialog: false,
             dialogconfirm: false,
            totalItems: 1000,
            page: 1,
            consultaDto: {
                Skip: 0,
                Take: 10,
                descending: true,
                sortBy: '',
                search: '',
                // idUsuario: 0,
                 extraParam: '3'
            },
            headers: [
                { text: 'Opciones', value: 'opciones', sortable: false },
                { text: 'Nombre', value: 'nombre', sortable: false },
                { text: 'NoEmpleado', value: 'noEmpleado' },
                { text: 'Correo', value: 'correo' },
            ],
            tiles: [{ img: 'messenger.png', title: 'Descarga' }],
            sheet: false,
            file: null,
            search: '',
            snackbar: false,
            snackbarcolor: '',
        }
    },
    watch: {
        dialog (val) {
        val || this.close()
        },
    },
    watch: {
        options: {
            handler () {
                this.listar()
                    // .then(data => {
                    //     this.desserts = data.items
                    //     this.totalDesserts = data.total
                    // })
            },
            deep: true
        }
    },
    methods: {
        listar(){
           let me = this
           debugger

            const { sortBy, sortDesc, page, itemsPerPage } = this.options
            var skip = (page - 1) * itemsPerPage
           
          
            this.loading = true
            me.consultaDto.Skip = skip
            me.consultaDto.Take = itemsPerPage
            me.consultaDto.search = me.search
            me.$store.dispatch('setIsBusy', true)
            me.$axios.post('api/Usuario/Get', me.consultaDto)
                .then(r => {
                    if (r.data.exito) {
                        me.totalItems = parseInt(r.data.mensaje)
                        me.catUsuario = r.data.datos
                    }
                    // this.$root.Mensaje(r.data.mensaje)
                    me.$store.dispatch('setIsBusy', false)
                })
                .catch(e => { console.log(e) })
        },
        select(item) {
            let me = this
            me.selectUser = item
            me.TituloNombre = item.nombre
            me.$store.dispatch('setIsBusy', true)
            me.consultaDto.idUsuario = item.idUsuario;
                 me.$axios.post('api/Usuario/GetSuperior',me.consultaDto)
                .then(r => {
                    if (r.data.exito) {
                        me.catUsuarioSuperior = r.data.datos
                    }
                    // this.$root.Mensaje(r.data.mensaje)
                    me.$store.dispatch('setIsBusy', false)
                })
                .catch(e => { console.log(e) })
            this.dialog = true
        },
        saveChange()
        {
            let me = this
          
            debugger
            me.$store.dispatch('setIsBusy', true)
            // me.selectSup.catUsuarioSuperior = me.catUsuarioSuperior; 
            // me.selectSup.idUsuario = me.consultaDto.idUsuario;
            // var aut = me.selectSup
            me.$axios.post('api/Usuario/SaveAutorizacion',{
                "idUsuario": me.consultaDto.idUsuario,
                "catUsuarioSuperior":me.catUsuarioSuperior,
            })
                .then(r => {
                    if (r.data.exito) {
                        // me.catUsuarioSuperior = r.data.datos
                         this.$root.Mensaje(r.data.mensaje)
                    }
                   
                    me.$store.dispatch('setIsBusy', false)
                })
                .catch(e => { console.log(e) })


               
            this.dialog = false
        },
        close() {
            this.dialog = false;
            setTimeout(() => {
               this.editedItem = Object.assign({}, this.defaultItem) 
               this.editedIndex = -1;
            }, 300);
        },
        descargaArchivo() {
            let me = this;

            debugger
            me.$store.dispatch('setIsBusy', true)    

            var url = "api/Usuario/downloadFile"

            me.$axios({
                    url: url,
                    method: 'GET',
                    crossDomain: true,
                    responseType: 'blob',
                }).then((response) => {
                        const url = window.URL.createObjectURL(new Blob([response.data]))
                        const link = document.createElement('a')
                        link.href = url
                        link.setAttribute('download', 'Layout_relacion_personalUP.xlsm')
                        document.body.appendChild(link)
                        link.click()
                        me.$store.dispatch('setIsBusy', false)
                        }).catch((error) =>  {
                            me.file = null;
                            me.$root.Mensaje("Intente de nuevo");
                            me.$store.dispatch('setIsBusy', false)
                  }
             );
         },
         uploadFile(){
            debugger
            let me = this;
            me.$store.dispatch('setIsBusy', true)
            if(me.file === null)
            { 
            
              me.$root.Mensaje("Elija un layout");
              me.$store.dispatch('setIsBusy', false)
              return;
            }
            let formData = new FormData();
            formData.append('file', me.file);
            
            me.$axios.post("api/Usuario/uploadFile", 
                formData, { headers: { 'Content-Type': 'multipart/form-data' }, file_name: "Layout_relacion_personal", responseType: 'blob'}
            ).then((response) => {
                  const url = URL.createObjectURL(new Blob([response.data], {
                      type: 'application/vnd.ms-excel.sheet.macroEnabled.12'
                  }))

                  debugger
                  me.file = null;
                  const link = document.createElement('a')
                  link.href = url
                  link.setAttribute('download', "Layout_relacion_personal")
                  link.style = "display: none";
                  document.body.appendChild(link)
                  link.click()
                  me.$store.dispatch('setIsBusy', false)
                  me.dialogconfirm = true
                  me.listar();
              
             })
            .catch((error) =>  {
                //  this.$root.Mensaje(error.response.data
                const reader = new FileReader();
                        reader.onload = function() {
                            const data = this.result;
                            me.$root.Mensaje(data);
                        };
                        reader.readAsText(error.response.data);
                        me.file = null;
                        me.$store.dispatch('setIsBusy', false)
                  }
             );
      },
    }
}
</script>